<template>
  <div class="study">
    <header class="study-title">
      {{title}}
      <span class="study-title__text">(今日新增数)</span>
    </header>
    <div class="study-number">
      <div :class="{'study-number__text': index!==3,
      'study-number__bottom': index === 3}"
        v-for="(item, index) in PrefixInteger(todayAdd, 6)"
        :key="index"
      >{{item}}</div>
    </div>
    <p class="study-add">累计:  {{Number(addNumber).toLocaleString()}}</p>
    <div v-if="title === '智适应学习'" class="study-issue">
      <div class="study-issue__number">
        <p>今日在线学习时长</p>
        <div>{{Number(issueNumber).toLocaleString()}}</div>
      </div>
      <div class="study-issue__number">
        <p>今日练习题目次数</p>
        <div>{{Number(testNumber).toLocaleString()}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdaptStudy',
  props: {
    title: {
      type: String,
      default: '智适应学习',
    },
  },
  data() {
    return {
      issueNumber: 50734,
      testNumber: 1890457,
      addNumber: 3784761,
      todayAdd: 649,
      timer: '',
    };
  },
  mounted() {
    if (this.title !== '智适应学习') {
      this.todayAdd = 178791;
    }
    this.getData();
    this.timer = setInterval(() => {
      this.issueNumber += Math.ceil(Math.random() * 400 + 100);
      this.testNumber += Math.ceil(Math.random() * 4000 + 1000);
      if (this.title === '智适应学习') {
        this.todayAdd += Math.ceil(Math.random() * 15 + 10);
      }
      if (this.title !== '智适应学习') {
        this.todayAdd += Math.ceil(Math.random() * 900 + 1000);
      }
      this.addNumber += this.todayAdd;
      sessionStorage.setItem(this.title === '智适应学习' ? 'adaptStudyData1' : 'adaptStudyData2', JSON.stringify({
        issueNumber: this.issueNumber,
        testNumber: this.testNumber,
        addNumber: this.addNumber,
        todayAdd: this.todayAdd,
      }));
    }, 60000);
  },
  methods: {
    PrefixInteger(num, length) {
      const newNum = (`0000000000000000${num}`).substr(-length);
      return this.insertStr(newNum, 3, ',');
    },
    accumulate(num) {
      console.log(num, 'num');
      return num + Math.ceil(Math.random() * 50 + 10);
    },
    insertStr(soure, start, newStr) {
      return soure.slice(0, start) + newStr + soure.slice(start);
    },
    getData() {
      const datas = JSON.parse(sessionStorage.getItem(this.title === '智适应学习' ? 'adaptStudyData1' : 'adaptStudyData2') || '{}');
      Object.keys(datas).forEach((key) => {
        this[key] = Number(datas[key]);
      });
    },
  },
  destroyed() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="scss" scoped>
  .study {
    box-sizing: border-box;
    width: 100%;
    max-height: 259px;
    padding: 20px;
    color: #f5f5f5;
    background: url('../../images/exhibition-study.png') no-repeat left top / 100% 100%;
    &-title {
      line-height: 24px;
      font-size: 20px;
      text-indent: 32px;
      margin-bottom: 20px;
      background: url('../../images/exhibition-icon.png') no-repeat left top / 24px;
      &__text {
        font-size: 15px;
        color: #E3E2FF;
      }
    }
    &-number {
      display: flex;
      font-size: 32px;
      text-align: center;
      &__text {
        width: 30px;
        height: 38px;
        line-height: 38px;
        margin-right: 10px;
        color: #f5f5f5;
        background: linear-gradient(180deg, #0A54EA 0%, #4D07CF 100%);
        border-radius: 2px;
        border: 1px solid rgba(112, 65, 255, 1);
        border-image: linear-gradient(180deg, rgba(55, 110, 255, 1), rgba(112, 65, 255, 1)) 1 1;
      }
      &__bottom {
        margin-right: 10px;
      }
    }
    &-add {
      font-size: 15px;
      margin-top: 14px;
      margin-bottom: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FCE204;
      line-height: 21px;
    }
    &-issue {
      display: flex;
      &__number {
        width: 150px;
        height: 80px;
        background: rgba(131, 92, 255, 0.2);
        border-radius: 4px;
        margin-right: 44px;
        p {
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #E3E2FF;
          margin-top: 12px;
          text-align: center;
        }
        div {
          text-align: center;
          font-size: 22px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          margin-top: 6px;
          color: #00DEFF;
        }
      }
    }
  }
</style>
